import { render, staticRenderFns } from "./CreateOf.vue?vue&type=template&id=b8c77c48&scoped=true&"
import script from "./CreateOf.vue?vue&type=script&lang=js&"
export * from "./CreateOf.vue?vue&type=script&lang=js&"
import style0 from "./CreateOf.vue?vue&type=style&index=0&id=b8c77c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c77c48",
  null
  
)

export default component.exports